import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ApellidoNombrePuesto } from '../funciones/FuncionesPersona.js';
import CampoBuscarClub from '../UI/campos/CampoBuscarClub.js';
import CuadroDatos from '../UI/CuadroDatos.js';
import TablaDatos from '../UI/TablaDatos.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './CorazonPartido.module.css';

const CorazonPartido = (props) => {
  const idClub = props.club && props.club.id;
  const [otroClub, setOtroClub] = useState(null);
  const [jugadores, setJugadores] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idClub && otroClub && otroClub.id) {
      const url = `clubes/${idClub}/jugadores/corazon_partido/${otroClub.id}`;
      fetchData(url, setJugadores);
    } else {
      setJugadores([]);
    }
  }, [fetchData, idClub, otroClub]);

  const onClubElegido = (nombre, club) => {
    setOtroClub(club);
  };

  return (
    <CuadroDatos titulo="Corazón partido" isCargando={isCargando} errores={erroresGetLista}>
      <div className={`${styles.selectorClub}`}>
        <span className={`${styles.label}`}>Otro club:</span>
        <CampoBuscarClub
          nombre="otroClub"
          valor={otroClub}
          editar={true}
          estilo={`${styles.campoClub}`}
          onClubElegido={onClubElegido}
        />
      </div>
      {otroClub && (
        <TablaDatos
          estilo={`${styles.tablaJugadores}`}
          lista={jugadores}
          textoVacia="No hay jugadores que hayan estado en ambos clubes"
        >
          <tbody className={`${styles.listaEquipos}`}>
            {jugadores &&
              jugadores.map((jugador) => (
                <tr key={jugador.id}>
                  <td className={`${styles.itemJugador}`}>
                    <Link
                      className={`${styles.linkJugador}`}
                      to={`/jugador/${jugador.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ApellidoNombrePuesto(jugador)}
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </TablaDatos>
      )}
    </CuadroDatos>
  );
};

export default CorazonPartido;
